<template>
    <span>
        <a v-if="isEdit == false" class="btn btn-primary btn-sm" @click="openModal">
            <i class="fa fa-plus"></i> Add Defect Group
        </a>
        <a v-if="isEdit == true" class="btn btn-primary btn-sm btn-circle" @click="openEditModal">
            <i class="fa fa-edit"></i>
        </a>
        <b-modal
            :id="'defectgroupformmodal'+ modalId"
            :title="formModal.title"
            @hidden="resetModal"
            @ok="handleSubmit"
            ok-title="Submit"
        >
            <form ref="form" @submit.stop.prevent="handleSubmit" novalidate>

                <b-form-group label="Name" label-for="name-input">
                    <b-form-input id="name-input" v-model="form.name" :state="validateState('name')"></b-form-input>
                </b-form-group>

                <b-form-group label="Context Helper" label-for="context_helper-input">
                    <b-form-textarea id="context_helper-input" v-model="form.context_helper"></b-form-textarea>
                </b-form-group>

            </form>
        </b-modal>
    </span>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
    props: ['componentId', 'formData', 'isEdit', 'modalId'],
    data(){
        return this.initData();
    },
    validations: {
        form: {
            name: { required }
        }
    },
    methods: {
        initData(){
            return {
                form: {
                    name: null,
                    context_helper: null
                },
                formModal: {
                    title: null
                },
                language: 'en',
            }
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        openModal(){
            this.formModal.title = "Add Defect Group";
            this.$bvModal.show('defectgroupformmodal' + this.modalId);
        },
        openEditModal(){
            this.formModal.title = "Edit Defect Group";
            this.form = JSON.parse(JSON.stringify(this.formData));
            this.$bvModal.show('defectgroupformmodal' + this.modalId);
        },
        resetModal(){
            Object.assign(this.$data, this.initData());
            this.$nextTick(() => { this.$v.$reset(); });
        },
        handleSubmit(bvModalEvt){
            bvModalEvt.preventDefault();
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            if(this.isEdit == true){
                this.submitUpdate();
            }else{
                this.submitSave();
            }
        },
        async submitSave(){
            try {
                await axios.post(
                    route("admin.houses.components.groups.store", this.componentId),
                    { form: this.form, language: this.language }
                );
                this.$swal('Saved!', '', 'success');
                this.$bvModal.hide('defectgroupformmodal' + this.modalId);
                this.$emit('update-list');
            } catch (e) {
                this.$swal('Error!', '', 'error');
            }
        },
        async submitUpdate(){
            try {
                await axios.put(
                    route("admin.houses.components.groups.update", [this.componentId, this.formData.id]),
                    { form: this.form, language: this.language }
                );
                this.$swal('Saved!', '', 'success');
                this.$bvModal.hide('defectgroupformmodal' + this.modalId);
                this.$emit('update-list');
            } catch (e) {
                this.$swal('Error!', '', 'error');
            }
        },
    }
}
</script>
